import { TokenHistoryTiming, TokenHistoryTimingNode } from "../../../types/dashboard";

/**
 * A run's wall-clock cost is the sum of its nodes' durations. The API only exposes `duration`
 * per node inside `data`, which is why the card that calls itself "Execution Times" never
 * actually showed one — the number was buried in the collapsed detail table.
 */
export const timingDuration: (timing: TokenHistoryTiming) => number | null = (
    timing: TokenHistoryTiming
): number | null => {
    if (!Array.isArray(timing?.data)) {
        return null;
    }
    let total: number = 0;
    let seen: boolean = false;
    timing.data.forEach((node: TokenHistoryTimingNode): void => {
        if (typeof node?.duration === 'number' && !Number.isNaN(node.duration)) {
            total = total + node.duration;
            seen = true;
        }
    });
    return seen ? total : null;
}

/** Total tokens for a run, request plus response. */
export const timingTokens: (timing: TokenHistoryTiming) => number = (
    timing: TokenHistoryTiming
): number => {
    return (timing?.request ?? 0) + (timing?.response ?? 0);
}

/** Longest run in the current page, used to scale the duration bars against each other. */
export const slowestDuration: (timings: TokenHistoryTiming[]) => number = (
    timings: TokenHistoryTiming[]
): number => {
    let max: number = 0;
    (timings ?? []).forEach((timing: TokenHistoryTiming): void => {
        const duration: number | null = timingDuration(timing);
        if (duration !== null && duration > max) {
            max = duration;
        }
    });
    return max;
}
